import { TFunction } from '@lyearn/i18n';
import { ILearningContent } from '@/modules/corporate/components/LearningContent/types';
import {
  ContentEntity,
  QuizContentType,
  ResourceTypeEnum,
  RoleplayContentType,
} from '@/types/schema';

const getQuestionsCount = (t: TFunction, content: QuizContentType) =>
  t('Common:ContentCards.Question', { count: content.quizQuestionsConfig.questionCount });

const getDuration = (t: TFunction, content: ContentEntity) => {
  if (content.type === ResourceTypeEnum.Quiz) {
    return getQuestionsCount(t, content as QuizContentType) as string;
  }

  if (content.type === ResourceTypeEnum.Roleplay) {
    const { conversationTimeLimit } = content as RoleplayContentType;
    if (conversationTimeLimit != null) {
      // conversationTimeLimit is in minutes; Duration component expects seconds
      return conversationTimeLimit * 60;
    }
  }

  return content.duration;
};

export const adaptContent = (
  t: TFunction,
  content: ContentEntity,
): ILearningContent & { isInGroup: boolean } => {
  return {
    ...content,
    image: content.cover?.url,
    duration: getDuration(t, content),
  };
};
